import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TooltipModule } from 'primeng/tooltip'
import { OptimizationTour } from '../../affair-pool-optimization.component.model'
import { TourStepView } from '../../affair-pool-optimization.types'
import {
  formatTime,
  formatFullDate,
  formatDuration,
  formatDistance,
} from '../../pool-optimization-formatters'

@Component({
  selector: 'app-pool-tour-header',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  templateUrl: './pool-tour-header.component.html',
  styleUrl: './pool-tour-header.component.scss',
})
export class PoolTourHeaderComponent {
  @Input() selectedTour: OptimizationTour | null = null
  @Input() startStep: TourStepView | null = null
  @Input() endStep: TourStepView | null = null
  @Input() canOpenTablotFiche = false
  @Input() tablotFicheUrl: string | null = null
  @Input() erosScheduleUrl: string | null = null
  @Input() googleMapsUrl: string | null = null
  /** Affaire vivier (manuelle ou existante) : programmation via dialog. */
  @Input() manualScheduleAvailable = false
  /** Affaire vivier manuelle sélectionnée : suppression du draft possible. */
  @Input() manualDeleteAvailable = false

  @Output() manualScheduleRequested = new EventEmitter<void>()
  @Output() manualDeleteRequested = new EventEmitter<void>()

  readonly formatTime = formatTime
  readonly formatFullDate = formatFullDate
  readonly formatDuration = formatDuration
  readonly formatDistance = formatDistance
}
